import React, { useEffect, useState } from "react";
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
import axios from "axios";
import "./AdminDashboard.css";

const AdminDashboard = () => {
    const [dashboardData, setDashboardData] = useState({
        upcomingEvents: 0,
        totalTickets: 0,
        totalRevenue: 0,
        activeUsers: 0,
        eventSales: [],
        highestSellingEvent: { name: "N/A", tickets: 0 },
        mostPopularTicketClass: { ticketClass: "N/A", count: 0 }
    });


    useEffect(() => {
        fetchDashboardData();
    }, []);

    const fetchDashboardData = async () => {
        try {
            const eventRes = await axios.get(`${process.env.REACT_APP_API_URL}/api/events`);
            const upcomingEvents = eventRes.data.length;
            console.log("✅ Events Response:", eventRes.data);

            const ticketRes = await axios.get(`${process.env.REACT_APP_API_URL}/api/tickets`);
            console.log("✅ Tickets Response:", ticketRes.data);

            const ticketsArray = ticketRes.data.tickets || [];

            const totalTickets = ticketsArray.length;
            const totalRevenue = ticketsArray.reduce((sum, ticket) => sum + ticket.totalPrice, 0);

            const userRes = await axios.get(`${process.env.REACT_APP_API_URL}/api/users`);
            const totalUsersVisited = userRes.data.length;

            console.log("📊 Total Users Visited:", totalUsersVisited);

            console.log("🎯 Fetched Event Data:", eventRes.data);
            console.log("🎯 Fetched Ticket Data:", ticketRes.data);

            const eventSales = eventRes.data.map(event => ({
                name: event.title,
                tickets: ticketsArray.filter(ticket => ticket.event?._id === event._id).length,
            }));

            const highestSellingEvent = eventSales.reduce((max, event) => event.tickets > max.tickets ? event : max, { name: "N/A", tickets: 0 });

            console.log("✅ Processed Dashboard Data:", { upcomingEvents, totalTickets, totalRevenue, eventSales });

            const ticketClassSales = ticketsArray.reduce((acc, ticket) => {
                acc[ticket.ticketClass] = (acc[ticket.ticketClass] || 0) + 1;
                return acc;
            }, {});
            const mostPopularTicketClass = Object.entries(ticketClassSales).reduce((max, [ticketClass, count]) =>
                count > max.count ? { ticketClass, count } : max, { ticketClass: "N/A", count: 0 });
            setDashboardData({
                upcomingEvents,
                totalTickets,
                totalRevenue,
                totalUsersVisited,
                eventSales,
                highestSellingEvent,
                mostPopularTicketClass
            });
        } catch (error) {
            console.error("Error fetching dashboard data:", error);
        }
    };
    return (
        <div className="admin-content">
            <h1>Welcome, Admin</h1>
            <p>Manage events, track sales, and oversee marketing.</p>

            <div className="dashboard-stats">
                <div className="stat-card">
                    <h3>Upcoming Events</h3>
                    <p>{dashboardData.upcomingEvents}</p>
                </div>
                <div className="stat-card">
                    <h3>Total Tickets Sold</h3>
                    <p>{dashboardData.totalTickets}</p>
                </div>
                <div className="stat-card">
                    <h3>Total Revenue</h3>
                    <p>{dashboardData.totalRevenue.toFixed(2)} JOD</p>
                </div>
                <div className="stat-card">
                    <h3>Total Users Visited</h3>
                    <p>{dashboardData.totalUsersVisited || 0}</p>
                </div>
                <div className="stat-card">
                    <h3>Best Selling Event</h3>
                    <p>
                        {dashboardData.highestSellingEvent?.name || "N/A"}
                        <br /> {/* ✅ Adds a line break */}
                        ({dashboardData.highestSellingEvent?.tickets || 0} tickets)
                    </p>                </div>

                <div className="stat-card">
                    <h3>Top Ticket Class</h3>
                    <p>
                        {dashboardData.mostPopularTicketClass?.ticketClass || "N/A"}
                        <br /> {/* ✅ Adds a line break */}
                        ({dashboardData.mostPopularTicketClass?.count || 0} sold)
                    </p>
                </div>
            </div>
                <div className="charts-section">
                <div className="chart-container">
                    <h2>Revenue Over Time</h2>
                    <ResponsiveContainer width="100%" height={300}>
                        <LineChart data={dashboardData.eventSales}>
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Line type="monotone" dataKey="tickets" stroke="#007bff" />
                        </LineChart>
                    </ResponsiveContainer>
                </div>

                <div className="chart-container">
                    <h2>Tickets Sold Per Event</h2>
                    <ResponsiveContainer width="100%" height={300}>
                        <BarChart data={dashboardData.eventSales}>
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="tickets" fill="#28a745" />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>
            <div className="recent-events">
                <h2>Recent Events</h2>
                <ul>
                    {dashboardData.eventSales.map((event, index) => (
                        <li key={index}>🎤 {event.name} - <span>{event.tickets} tickets sold</span></li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default AdminDashboard;
